export default __webpack_public_path__ + "static/faviconWhite-cc0d4ae1434ce5a32440a3c79699a1d7.ico";